// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__39t3G","info":"PatientInfo_info__AZquH"};